import React, { useMemo } from 'react';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import ProductTemplateSidebar from 'components/common/rfq/ProductTemplateSidebar';
import RFQPolicyAttributesForm from 'components/rfq/product-template/rfq-policy-attributes';
import RFQPolicyAttributesFormStore, {
  PageStoreContext,
} from 'store/pages/rfq/rfq-template/rfq-policy-attributes/pageStore';
import { createStyles } from '../../../../globalStyles';

const RFQPolicyAttributesPage = (): JSX.Element => {
  const pageStore = useMemo(() => new RFQPolicyAttributesFormStore(), []);

  const classes = createStyles();

  return (
    <GlobalLayout
      leftSection={<ProductTemplateSidebar />}
      rightSection={
        <div className={classes.pageWrapper}>
          <PageStoreContext.Provider value={pageStore}>
            <RFQPolicyAttributesForm />
          </PageStoreContext.Provider>
        </div>
      }
    />
  );
};

export default RFQPolicyAttributesPage;
